import React, { Component } from 'react';
import UrlParse from 'url-parse';
import Loading from '../../../components/loading';
import ApiBasicForm from './components/ApiBasicForm';
import { Card } from 'antd';
import { Link } from 'react-router-dom';

export class BasicPage extends Component {
	componentWillUnmount() {
		this.props.resetPage();
	}

	componentDidMount() {
		const { query } = UrlParse(this.props.location.search, true);
		const { id } = query;
		if (id) {
			this.props.getApiKeyById({ id });
		}
	}

	render() {
		const { pageProps, location } = this.props;
		const { loading, loadingSubmit } = pageProps;
		const { query } = UrlParse(location.search, true);

		if (loading) {
			return <Loading />;
		}

		return (
			<>
				{!query.id && (
					<>
						<Card style={{ marginTop: 7 }}>
							<>
								<p style={{ marginBottom: 10, fontSize: 11, color: '#707070' }}>
									<Link
										to="/api-keys"
										style={{ color: '#0074bc' }}
									>
										API Key Management
									</Link>{' '}
									/ New{' '}
								</p>
								<h3 style={{ margin: 0, color: '#00080D' }}>New API Key</h3>
							</>
						</Card>
					</>
				)}
				<div className="hall-custom-container">
					<ApiBasicForm
						loadingSubmit={loadingSubmit}
						onSubmit={this.props.onSubmit}
						{...this.props}
					/>
				</div>
			</>
		);
	}
}

export default BasicPage;
